import { render, staticRenderFns } from "./DealListModal.vue?vue&type=template&id=959ae8ba&scoped=true&"
import script from "./DealListModal.vue?vue&type=script&lang=js&"
export * from "./DealListModal.vue?vue&type=script&lang=js&"
import style0 from "./DealListModal.vue?vue&type=style&index=0&id=959ae8ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959ae8ba",
  null
  
)

export default component.exports